import { CSSProperties } from "react";
import { CardElementName } from "../../models/CardElement";

export type CrystalProps = {
    elements: CardElementName[],
    className?: string | undefined,
    styles?: CSSProperties | undefined
}

const elementColor: Record<CardElementName, React.CSSProperties> = {
    Fire: { fill: "#c52c1a" },
    Ice: { fill: "#62aac7" },
    Wind: { fill: "#52986c" },
    Earth: { fill: "#cbb944" },
    Lightning: { fill: "#a661aa" },
    Water: { fill: "#4168ab" },
    Light: { fill: "#909090" },
    Dark: { fill: "#222" }
}

export function Crystal(props: CrystalProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 191" className={`${props.className} overflow-hidden`} style={props.styles}>
            <path d="M96.208,35.026L47.5,0L-0.875,34.786L47.5,96.868L96.208,35.026Z" style={getStyle("top", props.elements)} />
            <path d="M95,156.859L95,34.157L46.082,97.339L92.212,156.859L95,156.859Z" style={getStyle("right", props.elements)} />
            <path d="M-1.292,155.916L47.5,191L95,156.859L46.649,94.409L-1.292,155.916Z" style={getStyle("bottom", props.elements)} />
            <path d="M0,34.157L0,156.845L0.007,156.85L47.5,95.508L0,34.157Z" style={getStyle("left", props.elements)} />
        </svg>
    )
}

function getStyle(position: "top" | "left" | "bottom" | "right", elements: CardElementName[]) {
    if (elements.length === 1) {
        return elementColor[elements[0]];
    }

    if (elements.length === 2) {
        if (position === "left" || position === "top") {
            return elementColor[elements[0]];
        } else {
            return elementColor[elements[1]];
        }
    }

    if (elements.length === 4) {
        switch (position) {
            case "left":
                return elementColor[elements[0]];
            case "top":
                return elementColor[elements[1]];
            case "right":
                return elementColor[elements[2]];
            case "bottom":
                return elementColor[elements[3]];
        }
    }
}